
export function initializeSentry() {
  console.log('Sentry not configured - skipping initialization');
}

export function captureError(error: Error, context?: Record<string, any>) {
  console.error('Error captured (Sentry not configured):', error, context);
}

export function captureMessage(message: string, level: 'info' | 'warning' | 'error' = 'info') {
  console.log(`[${level.toUpperCase()}] ${message}`);
}

export function setUserContext(user: any) {
  console.log('User context set (Sentry not configured):', user?.id);
}

export function addBreadcrumb(breadcrumb: { message: string; category?: string; level?: string; data?: any }) {
  console.log('Breadcrumb added (Sentry not configured):', breadcrumb.message);
}

export function withErrorBoundary<T>(Component: T, options?: any): T {
  // Return component as-is when Sentry is not available
  return Component;
}

export function startTransaction(name: string, op?: string) {
  console.log(`Transaction started (Sentry not configured): ${name}`);
  return {
    finish: () => console.log(`Transaction finished: ${name}`),
    setTag: (key: string, value: string) => {},
    setData: (key: string, value: any) => {}
  };
}

export function trackAPIRoute(route: string, method: string, options?: any) {
  console.log(`API route tracked (Sentry not configured): ${method} ${route}`);
  return {
    finish: (status?: number, error?: any, metadata?: any) => {
      console.log(`API route finished (Sentry not configured): ${method} ${route} - ${status}`);
    }
  };
}

export function trackAuthSuccess(userId: string) {
  console.log(`Auth success tracked (Sentry not configured): ${userId}`);
}

export function trackAuthFailure(error: string, context?: any) {
  console.log(`Auth failure tracked (Sentry not configured): ${error}`, context);
}